/// <amd-module name="Repos/Views/Settings/ProjectBranchPolicies/ReadableScope" />
import * as Resources from "Repos/Views/Settings/ProjectBranchPolicies/Resources";

var branchPatternRegex = /^\*?\:?refs\/heads\//;

export function transformScopeForDisplay(scope: string): string {
    switch (scope) {
        case "*":
        case "*:":
        case ":*":
        case "*:*":
        case "*:refs/heads":
        case "*:refs/heads/":
        case "*:refs/heads/*":
            return Resources.AllBranches;

        case "*:~default":
        case ":~default":
        case "~default":
            return Resources.DefaultBranch;
    }

    return scope.replace(branchPatternRegex, "");
}
